import React, { FC, ReactNode } from "react";
import { VpdScrollable } from "../vpd-scrollable";
import lib, { BookOutlined } from "@ant-design/icons";
import clsx from "clsx";
import styles from "./library.module.css";
import { Button } from "antd";
import { Icons } from "../vpd-icons/icons";

const {
  ["container"]: containerClassName,
  ["library-scrollable"]: libraryScrollableClassName,
  ["library-closed"]: libraryClosedClassName,
  ["library-opened"]: libraryOpenedClassName,
  ["library-closed-header"]: libraryClosedHeaderClassName,
} = styles as any;

export type LibraryProps = {
  open: boolean;
  setOpen: (open: boolean) => void;
  header?: ReactNode;
  content: ReactNode;
  showClose?: boolean;
  libraryText?: string;
};

export const Library: FC<LibraryProps> = ({
  open,
  setOpen,
  header,
  content,
  showClose,
  libraryText,
}) => {
  return (
    <>
      <div
        className={clsx(containerClassName, open ? libraryClosedClassName : libraryOpenedClassName)}
      >
        <header>
          <h1>
            <BookOutlined onClick={() => setOpen(true)} />
          </h1>
        </header>
      </div>
      <div
        className={clsx(containerClassName, open ? libraryOpenedClassName : libraryClosedClassName)}
      >
        <header>
          <h1>
            <div className={libraryClosedHeaderClassName}>
              <span>
                <BookOutlined /> {libraryText || "Library"}
              </span>
              {showClose && <Button icon={Icons.Close} onClick={() => setOpen(false)} />}
            </div>
          </h1>
          {header}
        </header>
        <VpdScrollable className={libraryScrollableClassName}>
          <main>{content}</main>
        </VpdScrollable>
      </div>
    </>
  );
};
